var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC2SwingGateOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v5.37c-7.44-3-16.38-4.49-27.12-4.49h-3.8V53H20V25h-2a17.61 17.61 0 00-9 2.7V24H3v33h70V24h-6zM16 53H9V32.85a13.08 13.08 0 017-3.64V53zm51 0H40V28.89c12.48.21 21.63 2.32 27 4.84V53zM43 42v-3a2 2 0 014 0v3a2 2 0 01-4 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C2_Swing_gate_open.66d2ed76.svg";
export { SvgC2SwingGateOpen as ReactComponent };